export const getAuthHeaders = (token?: string | null) =>
  token ? { Authorization: `Bearer ${token}` } : {};

export const getAuthConfig = (token?: string | null) => ({
  headers: getAuthHeaders(token),
});
